export const VIEW_SIZE = {
  xLarge: 'xLarge',
  large: 'large',
  medium: 'medium',
  small: 'small',
};
